import LocalStorageDao from '../dao/localstorage-dao';

const state = {
    userInfo: LocalStorageDao.loadUserInfo(),
    userId: '1',
    // userId: LocalStorageDao.loadUserInfo() ? '' : LocalStorageDao.loadUserInfo().id,
    userToken: LocalStorageDao.loadUserToken(),
    loginInfo: LocalStorageDao.loadAccount(),
    device: LocalStorageDao.loadDevice(),
    tabBar: LocalStorageDao.loadTabBar(),
    alivePage: LocalStorageDao.loadAlivePage(),
    innerTabBar: LocalStorageDao.loadInnerTabBar(),
    tatSimpleNames: [],
    serverType:'1',
    btnPerm: LocalStorageDao.loadBtnPermr(),
    tatId:'144a3ff3da0fbc619cc305a32d4e857c',
    reloadChnRateList: false,
    reloadAppAreaList:false,
    reloadTatNameList:false,
    reloadPage:false,
    currentOrgDetail:{},
    isLoading: false,
    basicInfoFlag: false,
};
export default state;



// WEBPACK FOOTER //
// ./src/store/db/states.js